<template><!-- svgo-optimised -->
<svg class="icon icon__wishlist" viewBox="0 0 14 17" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"><path d="M13 1H1v15l5.854-3.841L13 16z" stroke="#9F9F9F"/></svg>
</template>